import { useEffect, useState } from "react";
import { FacebookShareButton, FacebookIcon } from "react-share";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import dayjs from "dayjs";
import buddhistEra from "dayjs/plugin/buddhistEra";
import { locale } from "dayjs/locale/th";

dayjs.extend(buddhistEra);
dayjs.locale("th");

const showConsole = false;
export default function NewsContent(props) {
    const newsData = props.newsData;
    // const newsImage = `${process.env.REACT_APP_ACTDBMS_URL}uploads/activity/${newsData.act_date}_${newsData.act_code}/${newsData.act_poster}`;
    // const d = dayjs(newsData.act_date).format("YYYY-MM-DD");
    // const newsImage = dayjs(newsData.act_date).format("DD MMM BB");
    const newsImage = `${
        process.env.REACT_APP_ACTDBMS_URL
    }uploads/activity/${dayjs(newsData.act_date).format("YYYY-MM-DD")}_${
        newsData.act_code
    }/${newsData.act_poster}`;
    const pageTitle =
        "ข่าวกิจกรรมออนไลน์ คณะสถาปัตยกรรมศาสตร์และการออกแบบสิ่งแวดล้อม มหาวิทยาลัยแม่โจ้";
    const original = newsImage;
    const thumbnail = newsImage;
    const [galleryItems, setGalleryItems] = useState([{ original, thumbnail }]);

    useEffect(() => {
        document.head.innerHTML += `
        <title>${newsData.act_title}</title>
        <meta property="og:url" content="https://arch.mju.ac.th/news/${newsData.act_code}" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="${newsData.act_title}" />
        <meta property="og:description" content="${pageTitle}" />
        <meta property="og:image" content="${newsImage}" />
`;
        console.log("%cact_gallery:", "color:yellow", newsData.act_gallery);
        const items = [];
        newsData.act_gallery &&
            newsData.act_gallery.map((item) => {
                const original = `${
                    process.env.REACT_APP_ACTDBMS_URL
                }${item.img_filepath.replace("../", "/")}${item.img_filename}`;
                const thumbnail = `${
                    process.env.REACT_APP_ACTDBMS_URL
                }${item.img_filepath.replace("../", "/")}${item.img_filename}`;
                items.push({ original, thumbnail });
            });

        setGalleryItems(items);
        console.log("%cgallery:", "color:red", items);
        // eslint-disable-next-line
    }, []);

    function GenGallery(newsData) {
        try {
            if (newsData.act_gallery) {
                return newsData.act_gallery.map((item, index) => {
                    item.img_filepath = item.img_filepath.replace("../", "/");
                    // console.log("img_filepath:", item.img_filepath);
                    return (
                        <div key={index} className="col">
                            <a
                                href={`${process.env.REACT_APP_ACTDBMS_URL}${item.img_filepath}${item.img_filename}`}
                                target="act_image"
                            >
                                <img
                                    src={`${process.env.REACT_APP_ACTDBMS_URL}${item.img_filepath}${item.img_filename}`}
                                    alt=""
                                    className="img-thumbnail shadow"
                                    style={{
                                        minWidth: "100px",
                                        maxWidth: "400px",
                                        width: "100%",
                                    }}
                                />
                            </a>
                        </div>
                    );
                });
            }
        } catch (err) {
            console.log(err);
        }
    }

    showConsole && console.log("newsData:", newsData);
    showConsole && console.log("type galleryItems:", typeof galleryItems);
    showConsole && console.log("galleryItems:", galleryItems);

    return (
        <>
            <div
                className="container pt-4 px-2 px-md-4"
                style={{
                    position: "inherit",
                    marginTop: "30px",
                    backgroundColor: "white",
                    border: "1px solid",
                    padding: "40px",
                    boxShadow: "2px 6px 10px 4px #888888",
                    borderRadius: "15px",
                }}
            >
                <div
                    style={{
                        position: "sticky",
                        top: "50px",
                        // right: "0px",
                        // marginRight: "-14px",
                        width: "50px",
                    }}
                >
                    <div>
                        <FacebookShareButton
                            url={`https://arch.mju.ac.th/news/${newsData.act_code}`}
                            quote={newsData.act_title}
                            hashtag={newsData.act_category}
                        >
                            <FacebookIcon
                                size={32}
                                className="shadow rounded-5"
                                round
                            />
                        </FacebookShareButton>
                    </div>
                </div>
                <div
                    className="text-center"
                    style={{
                        marginTop: "0px",
                        fontWeight: "700",
                        letterSpacing: "1.4px",
                    }}
                >
                    <h5>{pageTitle}</h5>
                </div>
                <div className="row mt-4 p-4">
                    <div className="col-10 col-md-3">
                        <a href={newsImage} target="act_image">
                            <img
                                src={newsImage}
                                alt={newsData.act_title}
                                className="img-thumbnail shadow"
                            />
                        </a>
                    </div>
                    <div className="col-11 col-md-9 px-4">
                        <div
                            style={{
                                fontSize: "1.3em",
                                textAlign: "center",
                                color: "brown",
                                fontWeight: "500",
                                letterSpacing: "1.4px",
                            }}
                        >
                            {newsData.act_title}
                        </div>
                        <div
                            style={{
                                marginTop: "30px",
                                fontSize: "1.1em",
                                textAlign: "justify",
                                color: "#333333",
                                fontWeight: "300",
                                textIndent: "4em",
                                letterSpacing: "1.2px",
                                lineHeight: "1.8em",
                            }}
                        >
                            {newsData.act_memo}
                        </div>
                    </div>
                </div>
                <div style={{ marginTop: "40px" }}>
                    {console.log("galleryItems:", galleryItems)}
                    <ImageGallery items={galleryItems} />
                    {/* {galleryItems &&
                        galleryItems.length > 0 &&
                        galleryItems.map((item, index) => (
                            <div key={index} className="col">
                                <img
                                    src={item.img_filepath + item.img_filename}
                                    alt={`Gallery item ${item.img_filename}`}
                                    className="img-fluid"
                                />
                            </div>
                        ))} */}
                </div>
                <div
                    className="px-4 row row-cols-1 row-cols-md-2 row-cols-lg-3 row-cols-xl-4 g-5 text-center justify-content-around"
                    style={{ marginTop: "0" }}
                >
                    {/* {genGallery} */}
                    {/* {GenGallery(newsData)} */}
                </div>
            </div>
        </>
    );
}
